import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IAdminDashboard } from '../../core/types/admin-dashboard.interface';
import { ApiService } from '../../core/transport/api.service';
import { Endpoints } from '../../core/transport/endpoints';

@Injectable({ providedIn: 'root' })
export class AdminDashboardService {
  private readonly api = inject(ApiService);

  findAll(): Observable<IAdminDashboard> {
    return this.api.get<IAdminDashboard>(Endpoints.adminDashboard.summary);
  }
}
